class CartDrawerSection extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();

    this.cartType = this.dataset.cartType;
    this.drawerClass = "wt-cart__drawer";
    this.drawer = this.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--open`;
    this.pageOverlayClass = "page-overlay-cart";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;
    this.triggerQuery = [
      `.wt-cart__trigger`,
      `.wt-cart__back-link`,
      `.${this.pageOverlayClass}`,
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);
    this.isOpen = false;
    this.isCartPage = window.location.pathname === window.routes.cart_url;
    this.closeButton = () => this.querySelector(".wt-cart__drawer__close");
    this.mainTrigger = document.querySelector(".wt-cart__trigger");
    this.toggleEelements = () =>
      this.querySelectorAll(this.dataset.toggleTabindex);
  }

  connectedCallback() {
    if (this.cartType === "page" || this.isCartPage) {
      document.addEventListener("cart-drawer:refresh", (e) =>
        this.refreshCartDrawer(e),
      );
      return;
    }

    this.init();
    this.applyMobileCartCleanup();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (this.isOpen) {
        setTabindex(this.toggleEelements(), "0");
        this.closeButton().focus();
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
  }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      this.isOpen = false;
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "-1");
    } else {
      this.setAttribute("open", "");
      this.isOpen = true;
      this.closeButton().focus();
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "0");
    }
  }

  toggleDrawerClasses() {
    this.onToggle();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
    this.applyMobileCartCleanup();

    const eventName = this.isOpen
      ? PUB_SUB_EVENTS.cartDrawerOpen
      : PUB_SUB_EVENTS.cartDrawerClose;

    document.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
      }),
    );
  }

  // ==========================================
  // 新增：JS 控制 Footer 桌面端默认展开方法
  // ==========================================
  initFooterDefaultState() {
    const footer = this.querySelector('.wt-cart__drawer__footer');
    if (!footer) return;

    if (window.innerWidth >= 750) {
      footer.classList.add('is-open'); // 桌面端强行添加展开类名
    }
  }

  applyMobileCartCleanup() {
    this.injectMobileCartCleanStyles();
    this.updateMobileCartTitle();
  }

  injectMobileCartCleanStyles() {
    if (document.getElementById("ellerow-mobile-cart-clean-style")) return;

    const style = document.createElement("style");
    style.id = "ellerow-mobile-cart-clean-style";
    style.textContent = `
      @media screen and (max-width: 749px) {
        #CartDrawer.wt-cart__drawer {
          top: 8dvh !important;
          bottom: 0 !important;
          left: 0 !important;
          right: 0 !important;
          width: 100vw !important;
          max-width: 100vw !important;
          height: 92dvh !important;
          max-height: 92dvh !important;
          background: #ffffff !important;
          border-radius: 22px 22px 0 0 !important;
          overflow: hidden !important;
        }

        #CartDrawer .wt-cart__drawer__inner {
          display: flex !important;
          flex-direction: column !important;
          height: 100% !important;
          max-height: 100% !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border-radius: 22px 22px 0 0 !important;
        }

        #CartDrawer .wt-cart__drag-handle-wrapper {
          flex: 0 0 auto !important;
          padding: 12px 0 4px !important;
        }

        #CartDrawer .wt-cart__drag-handle {
          width: 48px !important;
          height: 5px !important;
          background-color: #d3d6da !important;
          border-radius: 999px !important;
        }

        #CartDrawer .wt-cart__drawer__header {
          flex: 0 0 auto !important;
          align-items: flex-start !important;
          min-height: auto !important;
          padding: 24px 20px 18px !important;
          border-bottom: 0 !important;
        }

        #CartDrawer #CartDrawer-TotalQty {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          margin: 0 !important;
          color: #050505 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 34px !important;
          font-weight: 400 !important;
          line-height: 1 !important;
          letter-spacing: 0 !important;
          text-transform: uppercase !important;
        }

        #CartDrawer .wt-cart__drawer-title-count {
          display: inline-block !important;
          padding-top: 1px !important;
          font-size: 18px !important;
          font-weight: 400 !important;
          line-height: 1 !important;
          color: #050505 !important;
        }

        #CartDrawer .wt-cart__drawer__close--button {
          display: none !important;
        }

        #CartDrawer .wt-cart__drawer__body {
          flex: 1 1 auto !important;
          height: 0 !important;
          min-height: 0 !important;
          padding: 0 20px !important;
          overflow-y: auto !important;
          overscroll-behavior: contain !important;
          -webkit-overflow-scrolling: touch !important;
        }

        #CartDrawer .wt-free-shipping-bar,
        #CartDrawer .delivery-container,
        #CartDrawer .shopify-discount-alert-card,
        #CartDrawer .cart-shipping-divider {
          display: none !important;
        }

        #CartDrawer .wt-cart__drawer__items,
        #CartDrawer .wt-cart__drawer__form,
        #CartDrawer .wt-cart__drawer__content {
          display: block !important;
          height: auto !important;
          min-height: 0 !important;
          width: 100% !important;
        }

        #CartDrawer .wt-cart__list {
          width: 100% !important;
          margin: 0 !important;
          padding: 12px 0 34px !important;
          list-style: none !important;
        }

        #CartDrawer .wt-cart__item {
          display: flex !important;
          align-items: flex-start !important;
          padding: 20px 0 30px !important;
          border-bottom: 0 !important;
        }

        #CartDrawer .wt-cart__item__thumb {
          flex: 0 0 108px !important;
          width: 108px !important;
          margin: 0 !important;
        }

        #CartDrawer .wt-cart__item__thumb img,
        #CartDrawer .wt-cart__item__thumb svg {
          width: 108px !important;
          height: 108px !important;
          max-width: 108px !important;
          object-fit: cover !important;
          border-radius: 0 !important;
          background: #f4eeee !important;
        }

        #CartDrawer .wt-cart__item__body {
          min-width: 0 !important;
          padding-left: 24px !important;
          flex: 1 1 auto !important;
          align-items: stretch !important;
        }

        #CartDrawer .wt-cart__item__data {
          min-width: 0 !important;
          padding-right: 30px !important;
        }

        #CartDrawer .wt-cart__item__name {
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 20px !important;
          font-weight: 400 !important;
          line-height: 1.25 !important;
          letter-spacing: 0 !important;
          color: #2b2b2b !important;
        }

        #CartDrawer .wt-cart__item__name a {
          color: inherit !important;
          text-decoration: none !important;
        }

        #CartDrawer .wt-cart__item__body .options {
          display: block !important;
          width: 100% !important;
          margin: 10px 0 12px !important;
          color: #777777 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 16px !important;
          font-weight: 400 !important;
          line-height: 1.35 !important;
          letter-spacing: 0 !important;
          text-transform: uppercase !important;
        }

        #CartDrawer .wt-cart__item__body .options .product-option {
          display: block !important;
          margin: 0 0 3px !important;
        }

        #CartDrawer .wt-cart__item-discount {
          margin: 8px 0 0 !important;
          color: #1e372f !important;
          font-size: 16px !important;
          font-weight: 400 !important;
          line-height: 1.25 !important;
          text-transform: none !important;
        }

        #CartDrawer .wt-cart__item__remove--title {
          top: -6px !important;
          right: 0 !important;
          opacity: 0.45 !important;
        }

        #CartDrawer .wt-cart__item__remove .svg-icon {
          width: 28px !important;
          height: 28px !important;
          transform: none !important;
        }

        #CartDrawer .wt-cart__item__amount.cart-page {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: nowrap !important;
          gap: 16px !important;
          width: 100% !important;
          margin: 14px 0 0 !important;
        }

        #CartDrawer .wt-cart__item__amount.cart-page .item__details {
          display: flex !important;
          flex: 1 1 auto !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 0 !important;
        }

        #CartDrawer .wt-cart__item__amount.cart-page cart-remove-button {
          display: none !important;
        }

        #CartDrawer quantity-counter.counter-wrapper,
        #CartDrawer .counter-wrapper {
          display: flex !important;
          justify-content: center !important;
        }

        #CartDrawer .counter {
          display: grid !important;
          grid-template-columns: 42px 52px 42px !important;
          align-items: center !important;
          justify-content: center !important;
          width: 136px !important;
          height: 52px !important;
          min-height: 52px !important;
          border: 1px solid #e0e0e0 !important;
          border-radius: 999px !important;
          background: #ffffff !important;
          overflow: hidden !important;
        }

        #CartDrawer .counter button {
          width: 42px !important;
          height: 52px !important;
          min-height: 52px !important;
          padding: 0 !important;
          color: #777777 !important;
          background: transparent !important;
          border: 0 !important;
        }

        #CartDrawer .counter input {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: #333333 !important;
          font-size: 24px !important;
          font-weight: 400 !important;
          line-height: 1 !important;
          text-align: center !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper {
          flex: 0 0 auto !important;
          min-width: 112px !important;
          text-align: right !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper .cart-item__discounted-prices {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-end !important;
          gap: 5px !important;
          width: auto !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper .cart-item__old-price,
        #CartDrawer .wt-cart__item__price-wrapper s {
          color: #2b2b2b !important;
          font-size: 18px !important;
          font-weight: 400 !important;
          line-height: 1.1 !important;
          text-decoration: line-through !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper .price,
        #CartDrawer .wt-cart__item__price-wrapper .price--end,
        #CartDrawer .wt-cart__item__price-wrapper .cart-item__final-price {
          color: #1e372f !important;
          font-size: 22px !important;
          font-weight: 400 !important;
          line-height: 1.1 !important;
        }

        #CartDrawer .wt-cart__drawer__footer {
          flex: 0 0 auto !important;
          padding: 22px 16px calc(22px + env(safe-area-inset-bottom, 0px)) !important;
          border-top: 1px solid #dedede !important;
          background: #ffffff !important;
          box-shadow: none !important;
        }

        #CartDrawer #CartDrawerFooterToggle {
          display: none !important;
        }

        #CartDrawer .wt-cart__footer-collapse-content,
        #CartDrawer .wt-cart__drawer__footer:not(.is-open) .wt-cart__footer-collapse-content {
          display: block !important;
          animation: none !important;
        }

        #CartDrawer .shopify-cart-shipping-row-container {
          margin: 0 0 60px !important;
        }

        #CartDrawer .cart-shipping-main-row {
          display: block !important;
        }

        #CartDrawer drawer-shipping-hint.shipping-hint,
        #CartDrawer .wt-cart__subtitle,
        #CartDrawer .wt-cart__footer .discounts,
        #CartDrawer .cart__dynamic-checkout-buttons,
        #CartDrawer .wt-featured-collection__button-container,
        #CartDrawer .wt-cart__show-cart,
        #CartDrawer .wt-cart__view-cart,
        #CartDrawer [class*="shipping-protection" i],
        #CartDrawer [id*="shipping-protection" i],
        #CartDrawer [class*="returns-protection" i],
        #CartDrawer [id*="returns-protection" i],
        #CartDrawer [class*="route" i],
        #CartDrawer [id*="route" i] {
          display: none !important;
        }

        #CartDrawer .wt-cart__footer__body #CartDrawer-Checkout ~ * {
          display: none !important;
        }

        #CartDrawer .wt-cart__giftnote.giftnote {
          display: block !important;
          margin: 0 !important;
        }

        #CartDrawer .giftnote__drawercart__addnote {
          display: inline-block !important;
          color: #222222 !important;
          font-size: 20px !important;
          font-weight: 400 !important;
          line-height: 1.2 !important;
          letter-spacing: 0 !important;
          text-decoration: underline !important;
          text-underline-offset: 3px !important;
        }

        #CartDrawer .wt-cart__footer__body {
          width: 100% !important;
          max-width: none !important;
        }

        #CartDrawer .wt-cart__subtotal {
          display: grid !important;
          grid-template-columns: auto 1fr !important;
          column-gap: 12px !important;
          row-gap: 2px !important;
          align-items: end !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        #CartDrawer .wt-cart__subtotal__label .text {
          color: #333333 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 18px !important;
          font-weight: 400 !important;
          line-height: 1.2 !important;
        }

        #CartDrawer .wt-cart__subtotal__value {
          justify-self: end !important;
          color: #242424 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 30px !important;
          font-weight: 400 !important;
          line-height: 1 !important;
          white-space: nowrap !important;
        }

        #CartDrawer .wt-cart__subtitle__text {
          display: block !important;
          margin: 4px 0 18px !important;
          color: #777777 !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 15px !important;
          font-weight: 400 !important;
          line-height: 1.25 !important;
          text-align: right !important;
        }

        #CartDrawer .wt-cart__cta,
        #CartDrawer .btn-checkout.wt-cart__cta {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          min-height: 64px !important;
          padding: 0 22px !important;
          border: 0 !important;
          border-radius: 999px !important;
          background: #173c31 !important;
          color: #ffffff !important;
          font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 24px !important;
          font-weight: 400 !important;
          line-height: 1 !important;
          letter-spacing: 0 !important;
          text-transform: uppercase !important;
        }
      }

      @media screen and (max-width: 390px) {
        #CartDrawer .wt-cart__drawer__header {
          padding-left: 16px !important;
          padding-right: 16px !important;
        }

        #CartDrawer .wt-cart__drawer__body {
          padding-left: 16px !important;
          padding-right: 16px !important;
        }

        #CartDrawer .wt-cart__item__thumb {
          flex-basis: 94px !important;
          width: 94px !important;
        }

        #CartDrawer .wt-cart__item__thumb img,
        #CartDrawer .wt-cart__item__thumb svg {
          width: 94px !important;
          height: 94px !important;
          max-width: 94px !important;
        }

        #CartDrawer .wt-cart__item__body {
          padding-left: 18px !important;
        }

        #CartDrawer .wt-cart__item__name {
          font-size: 18px !important;
        }

        #CartDrawer .wt-cart__item__body .options,
        #CartDrawer .wt-cart__item-discount {
          font-size: 14px !important;
        }

        #CartDrawer .counter {
          width: 124px !important;
          grid-template-columns: 38px 48px 38px !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper {
          min-width: 96px !important;
        }

        #CartDrawer .wt-cart__item__price-wrapper .price,
        #CartDrawer .wt-cart__item__price-wrapper .price--end,
        #CartDrawer .wt-cart__item__price-wrapper .cart-item__final-price {
          font-size: 20px !important;
        }

        #CartDrawer .wt-cart__subtotal__value {
          font-size: 26px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  getCartItemCountForTitle(titleElement) {
    const rawText = (titleElement.textContent || "").trim();
    const parenthesizedCount = rawText.match(/\((\d+)\)/);
    if (parenthesizedCount) return parenthesizedCount[1];

    const inlineCount = rawText.match(/\b(\d+)\b/);
    if (inlineCount) return inlineCount[1];

    const cartBubble = document.querySelector(
      ".cart-count-bubble span[aria-hidden='true'], .cart-count-bubble span:not(.visually-hidden), .cart-count-bubble, [data-cart-count]",
    );
    const bubbleCount = (cartBubble?.textContent || "").match(/\d+/);
    return bubbleCount ? bubbleCount[0] : "0";
  }

  updateMobileCartTitle() {
    const titleElement = this.querySelector("#CartDrawer-TotalQty");
    if (!titleElement) return;

    const count = this.getCartItemCountForTitle(titleElement);
    titleElement.classList.add("wt-cart__drawer-title");
    titleElement.setAttribute("aria-label", `Cart, ${count} item${count === "1" ? "" : "s"}`);
    titleElement.innerHTML = `
      <span class="wt-cart__drawer-title-word">CART</span>
      <span class="wt-cart__drawer-title-count">${count}</span>
    `;
  }

  initTouchGestures() {
    let startY = 0;
    let currentY = 0;
    let isDragging = false;
    let rafId = null;

    const CLOSE_THRESHOLD = 80;
    const maxDragDistance = 250;

    let overlay = null;

    this.addEventListener(
      "touchstart",
      (e) => {
        if (window.innerWidth > 749 || !this.isOpen) return;

        const drawerBody = this.querySelector(".wt-cart__drawer__body");
        if (drawerBody && drawerBody.scrollTop > 0) return;

        const handle = e.target.closest(
          "#CartDrawerDragHandle, .wt-cart__drawer__header",
        );
        if (!handle) return;

        const drawer = this.drawer;
        if (!drawer) return;

        overlay = document.querySelector(".page-overlay-cart");
        startY = e.touches[0].clientY;
        currentY = startY;
        isDragging = true;

        drawer.style.transition = "none";
        if (overlay) overlay.style.transition = "none";
        drawer.classList.add("is-dragging");
      },
      { passive: true },
    );

    window.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging) return;

        currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;

        if (deltaY > 0) {
          if (e.cancelable) e.preventDefault();

          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(() => {
            const drawer = this.drawer;
            if (!drawer) return;

            drawer.style.setProperty(
              "transform",
              `translate3d(0, ${deltaY}px, 0)`,
              "important",
            );

            if (overlay) {
              const progress = Math.min(deltaY / maxDragDistance, 1);
              overlay.style.opacity = (1 - progress).toString();
            }
          });
        }
      },
      { passive: false },
    );

    window.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;
      if (rafId) cancelAnimationFrame(rafId);

      const drawer = this.drawer;
      if (!drawer) return;

      drawer.classList.remove("is-dragging");
      const deltaY = currentY - startY;

      if (deltaY > CLOSE_THRESHOLD) {
        drawer.style.transition = "transform 0.25s cubic-bezier(0.25, 1, 0.5, 1)";
        drawer.style.setProperty("transform", "translate3d(0, 100%, 0)", "important");

        if (overlay) {
          overlay.style.transition = "opacity 0.25s cubic-bezier(0.25, 1, 0.5, 1)";
          overlay.style.opacity = "0";
        }

        setTimeout(() => {
          if (this.isOpen) {
            this.toggleDrawerClasses();
          }
          setTimeout(() => {
            drawer.style.removeProperty("transform");
            drawer.style.transition = "";
            if (overlay) {
              overlay.style.opacity = "";
              overlay.style.transition = "";
            }
          }, 100);
        }, 250);
      } else {
        drawer.style.transition = "transform 0.2s cubic-bezier(0.25, 1, 0.25, 1)";
        drawer.style.setProperty("transform", "translate3d(0, 0, 0)", "important");

        if (overlay) {
          overlay.style.transition = "opacity 0.2s cubic-bezier(0.25, 1, 0.5, 1)";
          overlay.style.opacity = "1";
        }

        setTimeout(() => {
          drawer.style.removeProperty("transform");
          drawer.style.transition = "";
          if (overlay) {
            overlay.style.opacity = "";
            overlay.style.transition = "";
          }
        }, 200);
      }

      startY = 0;
      currentY = 0;
    });
  }

  init() {
    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });

    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    this.addEventListener("click", (e) => {
      // 1. 修复电脑端点击关闭按钮内部 SVG 无响应问题（使用 closest）
      if (e.target.closest(".wt-cart__drawer__close")) {
        e.preventDefault();
        this.toggleDrawerClasses();
      }

      // 2. Footer Toggle 事件绑定
      const footerToggle = e.target.closest('#CartDrawerFooterToggle');
      if (footerToggle) {
        e.preventDefault();
        e.stopPropagation();
        const footer = this.querySelector('.wt-cart__drawer__footer');
        if (footer) {
          footer.classList.toggle('is-open');
        }
      }
    });

    // 初始化移动端下拉关闭手势
    this.initTouchGestures();

    // 初始化 Footer 桌面端默认展开状态
    this.initFooterDefaultState();
    window.addEventListener('resize', () => this.initFooterDefaultState());

    document.addEventListener("cart-drawer:refresh", (e) =>
      this.refreshCartDrawer(e),
    );
  }

  renderContents(parsedState, isClosedCart = true) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    // 每次 AJAX 局部更新购物车 DOM 后，重新确保桌面端 Footer 处于展开状态
    this.initFooterDefaultState();
    this.applyMobileCartCleanup();

    if (isClosedCart) {
      setTimeout(() => {
        this.toggleDrawerClasses();
        if (this.isOpen) {
          this.closeButton().focus();
        }
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  refreshCartDrawer(e) {
    const sectionsToRender = this.getSectionsToRender();
    fetch(
      `${window.Shopify.routes.root}?sections=${sectionsToRender[0].id},${sectionsToRender[1].id}`,
    )
      .then((response) => response.json())
      .then((response) => {
        const parsedState = {
          sections: response,
        };
        this.renderContents(parsedState, false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawerSection);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);